import type { RouteResources } from '@atlassian/react-resource-router';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { globalSettingsIssuesFieldConfigureRoute } from '@jira/router-routes__legacy-global-settings-issues-field-configure-routes/src/globalSettingsIssuesFieldConfigureRoute.tsx';
import { legacyPageEntrypoint } from '@jira/router-routes__legacy-page-entrypoint/src/legacyPageEntrypoint.entrypoint.tsx';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const globalSettingsIssuesFieldConfigureRouteEntry: JiraLegacyRoute<RouteResources> =
	createLegacyEntry(globalSettingsIssuesFieldConfigureRoute, () => ({
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
		},

		resources: [navigationSidebarGlobalResource],
		entryPoint: () => pageEntryPoint,
	}));
